import { motion } from "framer-motion";
import SectionLabel from "./SectionLabel";
import HoverVideo from "./HoverVideo";

// Placeholder featured slots. Fill in src (mp4) + poster (thumbnail image) as media is uploaded.
const featured = [
  {
    title: "Featured Episode 01",
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/76hbf05b_Talking%20Head%20Explainer%20Video%20-%20Clean%20Cuts%2C%20Lower%20Thirds%20%26%20Branded%20Captions_1080p.mp4",
    poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/3xgip9iy_d6GW62sTHLk-HD.jpg",
  },
  {
    title: "Featured Episode 02",
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/ug0zf6pj_High-Impact%20Full-Length%20Podcast%20Trailer%20Video%20Edit_1080p.mp4",
    poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/mpwxs4by_ogtdnkpTaCE-HD%20%281%29.jpg",
  },
  {
    title: "Featured Episode 03",
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/1ig6c9b8_youtube%20video%20%23_rezFBrHHDo_1080p.mp4",
    poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/y4hub23s__rezFBrHHDo-HD.jpg",
  },
  {
    title: "Featured Episode 04",
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/utlpx23z_Full-Length%20Podcast%20Trailer%20Video%20Optimized%20for%20YouTube%20Launch_1080p.mp4",
    poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/0bkvwi5p_mdezBykPed0-HD.jpg",
  },
  {
    title: "Featured Episode 05",
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/vog9u4r5_Full-Length%20Podcast%20Promo%20Trailer%20with%20Professional%20Sound%20Design_1080p%20%281%29.mp4",
    poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/7dzunzry_HIkv9_k3xkY-HD.jpg",
  },
];

export default function FeaturedWork() {
  const top = featured.slice(0, 3);
  const bottom = featured.slice(3, 5);

  return (
    <section
      id="work"
      data-testid="featured-work-section"
      className="relative px-6 md:px-16 lg:px-32 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
        <div>
          <SectionLabel number="01" label="Featured Work" testId="work-label" />
          <h2 className="font-display font-bold uppercase text-2xl md:text-4xl tracking-tighter leading-[0.95] [word-spacing:0.18em] max-w-3xl">
            Recent <span className="text-[#F4C75E]">podcast productions.</span>
          </h2>
        </div>
        <p className="text-sm md:text-base text-[#A3A3A3] max-w-sm">
          A selection of podcasts we've worked on. Hover over a thumbnail to watch the trailer.
        </p>
      </div>

      {/* Row 1, 3 cards */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-4 md:mb-6">
        {top.map((f, i) => (
          <motion.article
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`featured-item-${i}`}
            className="relative"
          >
            <HoverVideo
              withAudio
              src={f.src}
              poster={f.poster}
              alt={f.title}
              className="aspect-video w-full"
            />
          </motion.article>
        ))}
      </div>

      {/* Row 2, 2 cards */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {bottom.map((f, i) => (
          <motion.article
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`featured-item-${i + 3}`}
            className="relative"
          >
            <HoverVideo
              withAudio
              src={f.src}
              poster={f.poster}
              alt={f.title}
              className="aspect-video w-full"
            />
          </motion.article>
        ))}
      </div>
    </section>
  );
}
